// extracted by mini-css-extract-plugin
export default {"category":"ProductCategoryItem_category__dblJq","active":"ProductCategoryItem_active__0t5j3"};